import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { AppConfig } from 'src/app/core/_config/app.config';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class FileImportService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig) {}

    postFile(formData: FormData): Observable<ResponseCustom> {
        return this.http.post<ResponseCustom>(`${this.API_URL}BankReturnFile`, formData);
    }
}
